/* eslint-disable import/no-mutable-exports */
let COMMENT_NAMES = {};
let CHAT_GROUPS = [];

export function loadChatGroups(locales) {
  COMMENT_NAMES = {};
  Object.keys(locales.chatGroups).forEach((key) => {
    COMMENT_NAMES[key] = locales.chatGroups[key].name;
  });

  CHAT_GROUPS = [
    {
      name: 'Introduction',
      localeKey: 'introduction',
      localizedName: locales.chatGroups.introduction.name,
      localizedShort: locales.chatGroups.introduction.short,
    },
    {
      name: 'Project Summary',
      localeKey: 'projectSummary',
      localizedName: locales.chatGroups.projectSummary.name,
      localizedShort: locales.chatGroups.projectSummary.short,
    },
    {
      name: 'The Team',
      localeKey: 'theTeam',
      localizedName: locales.chatGroups.theTeam.name,
      localizedShort: locales.chatGroups.theTeam.short,
    },
    {
      name: 'Business Model Canvas',
      localeKey: 'businessModelCanvas',
      localizedName: locales.chatGroups.businessModelCanvas.name,
      localizedShort: locales.chatGroups.businessModelCanvas.short,
    },
    {
      name: 'Testing',
      localeKey: 'testing',
      localizedName: locales.chatGroups.testing.name,
      localizedShort: locales.chatGroups.testing.short,
    },
    {
      name: 'Desirability Section',
      localeKey: 'desirabilitySection',
      localizedName: locales.chatGroups.desirabilitySection.name,
      localizedShort: locales.chatGroups.desirabilitySection.short,
    },
    {
      name: 'Customer Segment',
      localeKey: 'customerSegment',
      localizedName: locales.chatGroups.customerSegment.name,
      localizedShort: locales.chatGroups.customerSegment.short,
    },
    {
      name: 'Value Proposition',
      localeKey: 'valueProposition',
      localizedName: locales.chatGroups.valueProposition.name,
      localizedShort: locales.chatGroups.valueProposition.short,
    },
    {
      name: 'Competitor Analysis',
      localeKey: 'competitorAnalysis',
      localizedName: locales.chatGroups.competitorAnalysis.name,
      localizedShort: locales.chatGroups.competitorAnalysis.short,
    },
    {
      name: 'Customer Relationships',
      localeKey: 'customerRelationships',
      localizedName: locales.chatGroups.customerRelationships.name,
      localizedShort: locales.chatGroups.customerRelationships.short,
    },
    {
      name: 'Channels',
      localeKey: 'channels',
      localizedName: locales.chatGroups.channels.name,
      localizedShort: locales.chatGroups.channels.short,
    },
    {
      name: 'Feasibility Section',
      localeKey: 'feasibilitySection',
      localizedName: locales.chatGroups.feasibilitySection.name,
      localizedShort: locales.chatGroups.feasibilitySection.short,
    },
    {
      name: 'Key Activities, Resources & Partners',
      localeKey: 'keyActivitiesResourcesPartners',
      localizedName: locales.chatGroups.keyActivitiesResourcesPartners.name,
      localizedShort: locales.chatGroups.keyActivitiesResourcesPartners.short,
    },
    {
      name: 'Viability Section',
      localeKey: 'viabilitySection',
      localizedName: locales.chatGroups.viabilitySection.name,
      localizedShort: locales.chatGroups.viabilitySection.short,
    },
    {
      name: 'Finance',
      localeKey: 'finance',
      localizedName: locales.chatGroups.finance.name,
      localizedShort: locales.chatGroups.finance.short,
    },
    {
      name: 'Sustainability',
      localeKey: 'sustainability',
      localizedName: locales.chatGroups.sustainability.name,
      localizedShort: locales.chatGroups.sustainability.short,
    },
    {
      name: 'Contact Us',
      localeKey: 'contactUs',
      localizedName: locales.chatGroups.contactUs.name,
      localizedShort: locales.chatGroups.contactUs.short,
    },
  ];
}

export function getCommentName(name) {
  const entry = CHAT_GROUPS.find(
    (item) => item.name.toLowerCase() === name.toLowerCase(),
  );
  return entry ? COMMENT_NAMES[entry.name] : name;
}

export function getChatGroupByName(name) {
  return CHAT_GROUPS.find((g) => g.name.toLowerCase() === name.toLowerCase());
}

export function getLocalizedChatGroupName(name) {
  const entry = CHAT_GROUPS.find(
    (item) => item.name.toLowerCase() === name.toLowerCase(),
  );
  if (entry && COMMENT_NAMES[entry.localeKey]) {
    return COMMENT_NAMES[entry.localeKey];
  }
  return name;
}

export function getShortNameOfChatGroup(name) {
  return CHAT_GROUPS.find(
    (item) => item.name.toLowerCase() === name.toLowerCase(),
  )?.localizedShort;
}

export function getAllChatGroups() {
  return CHAT_GROUPS;
}

export { COMMENT_NAMES, CHAT_GROUPS };
